<template>

	<Layout>
		<Sider hide-trigger id="sider" width="300" collapsed-width="10" breakpoint="xl">
			<Tree :data="data2" :show-checkbox="true" ref="tree4" @on-check-change="treeChange" :check-strictly="true"
				:check-directly="true"></Tree>
		</Sider>
		<Layout>
			<Content>
				<div>
					<Form ref="form" :model="data" :label-width="120" label-position="right">
						<Row type="flex" justify="center" align="middle">
							<Col :span="5">
							<FormItem label="用户名：" prop="userName" label-for="userName">
								<Input v-model="data.userName" placeholder="请输入" element-id="userName" />
							</FormItem>
							</Col>
							<Col :span="6">
							<FormItem label="登录账户：" prop="loginId" label-for="loginId">
								<Input v-model="data.loginId" placeholder="请输入" element-id="loginId" />
							</FormItem>
							</Col>
							<Col :span="6" class="ivu-text-right">
							<!-- <Col  v-bind="grid" class="ivu-text-right"> -->
							<FormItem>
								<Button type="primary" @click="selectSubmit">查询</Button>
								<Button @click="handleReset('form')" style="margin-left: 20px">重置</Button>
							</FormItem>
							</Col>
						</Row>
					</Form>

					<Button type="success" ghost size="large" @click="userMainAdd()">新增用户</Button>

					<Table :columns="columns1" :data="data1">
						<template slot="action" slot-scope="{ row, index }">
							<Button type="info" ghost size="small" style="margin-right: 5px"
								@click="userMainEdit(row)">编辑</Button>
							<Button type="info" ghost size="small" style="margin-right: 5px"
								@click="userPassWdResetMain(row)">密码重置</Button>
							<Button type="info" ghost size="small" style="margin-right: 5px"
								@click="updateUserStatusMain(row)">注销</Button>
							<Button type="warning" ghost size="small" style="margin-right: 5px"
								@click="roleConfigMain(row)">配置角色</Button>
							<Button type="error" ghost size="small" @click="userDeleteMain(row)">删除</Button>
						</template>
					</Table>
					<Page id="page" :total="pageTotal" :current="pageNum" :page-size="pageSize" @on-change="handlePage"
						show-total show-elevator next-text="下一页" />
				</div>

				<div>
					<Modal v-model="modal3" title="配置角色" width="40%" :loading="submitting" @on-ok="roleConfig()">
						<CheckboxGroup v-model="data4" @on-change="change">
							<Checkbox :label="item.roleId+':'+item.roleName" v-for="item in data3"
								v-bind:key="item.roleId"></Checkbox>
						</CheckboxGroup>
					</Modal>
				</div>




				<div>
					<Modal v-model="modal1" title="用户新增" width="30%" :loading="submitting" @on-ok="userAddfunc()">
						<Form ref="modalformValidata" :model="modalformValidata" :rules="ruleValidate">
							<FormItem label="所属部门：" prop="deptName">
								<Input v-model="modalformValidata.deptName" disabled />
							</FormItem>
							<FormItem label="用户姓名：" prop="userName">
								<Input v-model="modalformValidata.userName" />
							</FormItem>
							<FormItem label="登录账户：" prop="loginId">
								<Input v-model="modalformValidata.loginId" />
							</FormItem>
							<FormItem label="登录密码：" prop="loginPwd">
								<Input v-model="modalformValidata.loginPwd" type="password" />
							</FormItem>
							<div>
								注:密码必须是大写字母，小写字母，数字，特殊字符组成且长度为8到20位！
							</div>
							<FormItem label="联系电话：" prop="userTel">
								<Input v-model="modalformValidata.userTel" />
							</FormItem>

							<RadioGroup v-model="modalformValidata.userGender">
								<Radio label="1">
									<span>男</span>
								</Radio>
								<Radio label="2">
									<span>女</span>
								</Radio>
							</RadioGroup>

							<FormItem label="用户备注：" prop="userDesc">
								<Input v-model="modalformValidata.userDesc" type="textarea" :rows="4" />
							</FormItem>
						</Form>
					</Modal>
				</div>



				<div>
					<Modal v-model="modal2" title="角色编辑" width="20%" :loading="submitting" @on-ok="userEditFunc()">
						<Form ref="modalformValidata" :model="modalformValidata" :rules="ruleValidate">
							<FormItem label="所属部门：" prop="deptName">
								<Input v-model="modalformValidata.deptName" disabled />
							</FormItem>
							<FormItem label="用户姓名：" prop="userName">
								<Input v-model="modalformValidata.userName" />
							</FormItem>
							<FormItem label="联系电话：" prop="userTel">
								<Input v-model="modalformValidata.userTel" />
							</FormItem>

							<RadioGroup v-model="modalformValidata.userGender">
								<Radio label="1">
									<span>男</span>
								</Radio>
								<Radio label="2">
									<span>女</span>
								</Radio>
							</RadioGroup>

							<FormItem label="用户备注：" prop="userDesc">
								<Input v-model="modalformValidata.userDesc" type="textarea" :rows="4" />
							</FormItem>
						</Form>
					</Modal>
				</div>


			</Content>
		</Layout>
	</Layout>


</template>
<script>
	//分页的初始参数
	const paramter = {
		page: 1,
		pagesize: 10,
		ispage: 'Y',
		userName: null,
		loginId: null,
		deptId: null,
	};

	import {
		getLeftDeptTreer,
		getLeftMenuTree,
		getUserList,
		getUserSingle,
		userAdd,
		userEdit,
		updateUserStatus,
		userDelete,
		updateUserPwd,
		useResetPwd,
		configUserRoles,
		deptGet,
		userSameUser,
		getRoleList,
		selectBaseRoleByUserId
	} from '@/network/index.js';

	export default {
		name: "BaseRole",
		props: {

		},
		components: {

		},

		data() {
			//判断密码输入的是否正确
			const validatePass = (rule, value, callback) => {
				if (value === '') {
					callback(new Error('请输入密码'));
				} else {
					//  密码长度最少8位、必须包含字母和数字 必须包含$或*号
					console.log("-------:" + value.length)
					//                if(value.length<8){
					//  callback(new Error('密码长度小于8位数！'));
					// }
					//密码验证
					let passwordreg = /(?=.*\d)(?=.*[a-zA-Z])(?=.*[^a-zA-Z0-9]).{8,20}/
					let isValid = passwordreg.test(value);
					if (isValid != true) {
						//this.loading = false;
						callback(new Error('密码必须是大写字母，小写字母，数字，特殊字符组成，且长度为8到20位！'));
					}

					callback();
				}
			};


			//判断用户名是否已经存在
			const validateUserLoginId = (rule, value, callback) => {
				//this.$Message.success('hahaah!'+value);
				debugger;
				if (value === '') {
					callback(new Error('请输入用户名'));
				} else {
					let sameCount = 0;

					userSameUser({
							loginId: value
						}).then(res => {
							//console.log('res.obj:'+ res.data.obj);
							sameCount = res.data.obj;
							if (sameCount > 0) {
								callback(new Error('用户名已存在，请重新你输入!'));
							} else {
								callback();
							}
						})
						.catch(error => {
							this.$Message.success('后台出错，请联系管理员!');
						});


				}
			};


			return {
				columns1: [{
						title: '用户id',
						key: 'userId',
						width: 80,
						fixed: 'left',
					},
					{
						title: '用户名',
						key: 'userName',
						width: 130,
						fixed: 'left',
					},
					{
						title: '登录账号',
						key: 'loginId',
						width: 100,
						fixed: 'left',
					},
					{
						title: '性别',
						key: 'userGender',
						width: 80,
					},
					{
						title: '联系电话',
						key: 'userTel',
						width: 150,
					},
					{
						title: '部门id',
						key: 'deptId',
						width: 100,
					},
					{
						title: '用户状态',
						key: 'userStatus',
						width: 100,
					},
					{
						title: '创建时间',
						key: 'createTime',
						width: 180,
					},
					{
						title: '备注',
						key: 'userDesc',
					 
					},
					{
						title: '操作',
						slot: 'action',
						width: 340,
						align: 'center',
						fixed: 'right',
					}

				],
				pageTotal: 0,
				pageNum: 1,
				pageSize: 10,
				data2: [], //部门树
				data3: [], //角色
				data4: [], //选中的角色
				data: { //查询条件
					userName: '',
					loginId: '',
				},
				data1: [], //table中显示的数据
				modal1: false,
				modal2: false,
				modal3: false,
				submitting: true,
				loading: false,
				checkId: true,
				userId: '',
				roIds: '',
				modalformValidata: {
					userId: '',
					userName: '',
					loginId: '',
					loginPwd: '',
					deptId: '',
					deptName: '',
					userDesc: '',
					userTel: '',
					userGender: '1',
				},
				ruleValidate: {
					userName: [{
						required: true,
						message: '用户名必须填写',
						trigger: 'blur'
					}],
					loginId: [{
						required: true,
						validator: validateUserLoginId,
						trigger: 'blur'
					}],
					loginPwd: [{
						required: true,
						validator: validatePass,
						trigger: 'blur'
					}],
				}

			}
		},
		created() {
			this.initData();

		},
		methods: {
			//初始化部门信息
			initData() {
				getLeftDeptTreer().then(res => {
					//数据清空
					this.data2 = [];
					this.data2.push({
						deptId: res.data.obj.deptId,
						title: res.data.obj.title,
						children: res.data.obj.children,

						expand: true,
						selected: true,

					});
				});
				this.getUserListFunc(paramter);

			},
			//页面变更
			handlePage(value) {
				console.log('value:' + value);
				this.pageNum = value;
				paramter.page = value;

				this.initData()
			},

			//用户状态字典表转换
			dic1(value) {
				if ("normal" == value) {
					return '正常'
				}
				if ("logout" == value) {
					return '注销'
				}
				if ("locked" == value) {
					return '锁定'
				}
				if ("delete" == value) {
					return '删除'
				}
				return value
			},

			//用户性别字典表转换
			dic2(value) {
				if ("1" == value) {
					return '男'
				}
				if ("2" == value) {
					return '女'
				}
				return value
			},

			//用户性别字典表转换
			dic3(value) {
				if ("男" == value) {
					return '1'
				}
				if ("女" == value) {
					return '2'
				}
				return value
			},


			//获用户列表
			getUserListFunc(paramter) {
				getUserList(paramter).then(res => {
						// console.log(res);
						this.pageTotal = res.data.page.count;
						this.pageSize = res.data.page.pagesize;
						this.pageNum = res.data.page.page;
						//数据清空
						this.data1 = [];
						for (var i = 0; i < res.data.obj.dataList.length; i++) {
							this.data1.push({
								userId: res.data.obj.dataList[i].userId,
								userName: res.data.obj.dataList[i].userName,
								loginId: res.data.obj.dataList[i].loginId,
								userDesc: res.data.obj.dataList[i].userDesc,
								userTel: res.data.obj.dataList[i].userTel,
								userGender: this.dic2(res.data.obj.dataList[i].userGender),
								deptId: res.data.obj.dataList[i].deptId,
								userStatus: this.dic1(res.data.obj.dataList[i].userStatus),
								createTime: res.data.obj.dataList[i].createTime,
							});


						}

					})
					.catch(error => {});
			},

			//查询提交
			selectSubmit() {

				if (this.data.userName != null && this.data.userName != '') {
					paramter.userName = this.data.userName;
				}
				if (this.data.loginId != null && this.data.loginId != '') {
					paramter.loginId = this.data.loginId;
				}

				this.getUserListFunc(paramter);

			},

			//重置
			handleReset(name) {
				this.$refs[name].resetFields();
				paramter.userName = null;
				paramter.loginId = null;
			},


			//用户密码重置
			userPassWdResetMain(row) {
				useResetPwd(row.userId, null).then(res => {
						if (res.success == true) {
							this.$Message.success('用户密码重置成功!');
							this.modal2 = false;
							this.getUserListFunc(paramter);
						} else {
							this.$Message.error(res.message);
						}
					})
					.catch(error => {
						console.log(error)
					});
			},

			//用户删除
			userDeleteMain(row) {
				userDelete(row.userId, null).then(res => {
						if (res.success == true) {
							this.$Message.success('用户删除成功!');

							this.getUserListFunc(paramter);
						} else {
							this.$Message.error(res.message);
						}
					})
					.catch(error => {
						console.log(error)
					});
			},


			//用户注销
			updateUserStatusMain(row) {
				let paramterTemp = {
					userStatus: 'logout',
				};

				updateUserStatus(row.userId, paramterTemp).then(res => {
						if (res.success == true) {
							this.$Message.success('用户注销成功!');
							this.modal2 = false;
							this.getUserListFunc(paramter);
						} else {
							this.$Message.error(res.message);
						}
					})
					.catch(error => {
						console.log(error)
					});
			},

			//用户主方法编辑
			userMainEdit(row) {
				this.modal2 = true;

				//获取父部门的名称
				deptGet(row.deptId, paramter).then(res => {
						this.modalformValidata.deptName = res.data.obj.deptName;
					})
					.catch(error => {
						console.log(error)
					});

				this.modalformValidata.deptId = paramter.deptId;
				this.modalformValidata.userId = row.userId;
				this.modalformValidata.userName = row.userName;
				this.modalformValidata.userDesc = row.userDesc;
				this.modalformValidata.userTel = row.userTel;
				this.modalformValidata.userGender = this.dic3(row.userGender);
			},
			//用户编辑
			userEditFunc() {

				let paramter = {
					deptId: this.modalformValidata.deptId,
					userName: this.modalformValidata.userName,
					userDesc: this.modalformValidata.userDesc,
					userTel: this.modalformValidata.userTel,
					userGender: this.modalformValidata.userGender,
				};
				userEdit(this.modalformValidata.userId, paramter).then(res => {
						if (res.success == true) {
							this.$Message.success('用户编辑成功!');
							this.modal2 = false;
							//编辑后刷新数据
							let paramtertemp = {
								deptId: paramter.deptId,
							};
							this.getUserListFunc(paramtertemp);
						} else {
							this.$Message.error(res.message);
						}
					})
					.catch(error => {
						this.$Message.success('用户编辑失败，请联系管理员!');
					});
			},


			//用户新增 弹出模态框
			userMainAdd() {
				//debugger;
				if (paramter.deptId == null) {
					this.$Message.error("请选择部门！");
					return;
				} else {
					this.modal1 = true;

					//获取父部门的名称
					deptGet(paramter.deptId, paramter).then(res => {
							this.modalformValidata.deptName = res.data.obj.deptName;
						})
						.catch(error => {
							console.log(error)
						});

					this.modalformValidata.deptId = paramter.deptId;
				}


			},



			//用户新增
			userAddfunc() {

				let paramter = {
					deptId: this.modalformValidata.deptId,
					userName: this.modalformValidata.userName,
					loginId: this.modalformValidata.loginId,
					loginPwd: this.modalformValidata.loginPwd,
					userTel: this.modalformValidata.userTel,
					userGender: this.modalformValidata.userGender,
					userDesc: this.modalformValidata.userDesc,
					isLogin: '1',
				};

				userAdd(paramter).then(res => {
						if (res.success == true) {
							this.$Message.success('用户添加成功!');
							this.modal1 = false;
							//添加后刷新数据
							let paramtertemp = {
								deptId: paramter.deptId,
							};
							this.getUserListFunc(paramtertemp);
						} else {
							// 官方目前没有解决方案
							this.modal1.loading = false;

							this.$Message.error(res.message);
						}
					})
					.catch(error => {
						this.$Message.success('用户添加失败，请联系管理员!');
						//添加失败关闭对话框
						this.submitting = false;

					});



			},

			// 选中树节点触发的方法
			handleSelectChange(root, node) {
				console.log('root' + root);
				console.log('node' + node);
			},



			// 树复选框发生改变--只能有一个被选中
			treeChange(arr, obj) {
				// 清空所有已选中的
				arr.forEach(item => {
					item.checked = false;
				});
				// 只选中最后一次选中的
				obj.checked = true;
				this.checkId = obj.deptId;
				paramter.deptId = obj.deptId;
				this.getUserListFunc(paramter);

				// debugger;
				// 　let choicesAll=this.$refs.tree4.getCheckedNodes; //方法的运用 getSelectedNodes也是如此用法
				// 　　　　console.log(choicesAll.title); 
			},



			change(data) { //事件写在Checkbox-group里返回的是选中的数组，写在Checkbox返回的是boolean值
				this.roIds = '';
				
				let temp = JSON.stringify(data);
				let arry = temp.split(',');
				for (var i = 0; i < arry.length; i++) {
					if ('' == this.roIds) {
						this.roIds = arry[i].split(":")[0].replaceAll('["', '');
					} else {
						this.roIds = this.roIds + ',' + arry[i].split(":")[0].replaceAll('["', '');
					}
				}
				this.roIds = this.roIds.replaceAll('"', ''); 
			},
			//配置用户需要的角色
			roleConfigMain(row) {

				this.modal3 = true;
                this.userId = row.userId;
				//获角色列表
				//只看根目录下的角色
				paramter.deptId = '10000';
				getRoleList(paramter).then(res => {
						//数据清空
						this.data3 = [];
						for (var i = 0; i < res.data.obj.dataList.length; i++) {
							this.data3.push({
								roleId: res.data.obj.dataList[i].roleId,
								roleName: res.data.obj.dataList[i].roleName,
							});
						}
					})
					.catch(error => {});
					
		 
				//查看已有的角色	 
				selectBaseRoleByUserId({userId:this.userId}).then(res => {
						//数据清空
						this.data4 = [];
						for (var i = 0; i < res.data.obj.length; i++) {
							this.data4.push(res.data.obj[i].roleId+':'+res.data.obj[i].roleName );	 
						}
					})
					.catch(error => {});
				// this.data4 = '['+this.data4+']';	
			},
			
			roleConfig(){
				 
				let paramter = {
					roleIds: this.roIds, 
				};
				
				configUserRoles(this.userId,paramter).then(res => {
						if (res.success == true) {
							this.$Message.success('用户角色配置成功!');
							this.modal3 = false;
							 
						} else {
							// 官方目前没有解决方案
							this.modal3.loading = false;
				
							this.$Message.error(res.message);
						}
					})
					.catch(error => {
						this.$Message.success('用户角色配置失败，请联系管理员!');
						//添加失败关闭对话框
						this.submitting = false;
				
					});
			},


		}
	}
</script>


<!-- <style lang="scss" scoped> -->
<style lang="scss">
	/* 让方形复选框变成圆形单选框样式，最好在树组件外套一个父盒子，在样式前加父级选择器，以免影响其他树组件  scoped去掉就无效*/

	// .ivu-checkbox-inner {
	// 	border-radius: 50px;
	// }


	.ivu-form-item {
		margin-bottom: 10px;
		margin-top: 10px;
	}

	.ivu-layout-sider {
		background: #ffffff;
	}

	#sider {
		background: #f7fbff;
	}
</style>
